import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ede7383c")

_pushScopeId("data-v-ede7383c")
const _hoisted_1 = { class: "log-location padding10px" }
const _hoisted_2 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_popover = _resolveComponent("el-popover")

  return (_ctx.isToLong)
    ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        trigger: "hover",
        width: 200
      }, {
        reference: _withId(() => [
          _createVNode("span", null, _toDisplayString(_ctx.limitedLocationStr), 1)
        ]),
        default: _withId(() => [
          _createVNode("div", _hoisted_1, _toDisplayString(_ctx.locationStr), 1)
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock("label", _hoisted_2, _toDisplayString(_ctx.locationStr), 1))
})